import { Tile } from '@sortlist-frontend/design-system';
import { Check } from '@sortlist-frontend/design-system/icons';
import type { ReactNode } from 'react';

interface ToggleItemProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: ReactNode;
}

export const ToggleItem = (props: ToggleItemProps) => {
  const { checked, onChange, children } = props;

  return (
    <label className="flex cursor-pointer items-start gap-3 rounded-2xl border border-secondary-200 bg-white p-4 transition-colors has-[:checked]:border-primary-300 has-[:checked]:bg-primary-50">
      <input
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        className="peer sr-only"
      />
      <Tile
        size="2xs"
        color="primary"
        variant="bordered"
        radius="full"
        className="mt-0.5 text-transparent peer-checked:bg-primary-500 peer-checked:text-white">
        <Check />
      </Tile>
      <span className="text-sm leading-relaxed text-secondary-700">{children}</span>
    </label>
  );
};
